<ng-container *ngIf="!item.hidden">

  <li [ngClass]="item.classes " *ngIf="item.url && !item.external" [routerLinkActive]="['active']" class="d-flex">
    <a class="nav-link  w-100" [target]="item.target ? '_blank' : '_self'" [routerLink]="[item.url]"   (click)="closeOtherMenu($event,true);clear(item.url,item.title)">
      <ng-container *ngTemplateOutlet="itemIcon"></ng-container>
      <span class="pcoded-mtext" *ngIf="item.icon; else directTitle">{{ item.title }}</span>
      <ng-template #directTitle>
        {{ item.title }}
      </ng-template>
      <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
    </a>
    <input class="form-check-input chbutton" type="checkbox"  (click)="checked()" id="checkbox" *ngIf="item.url=='/showbubble'">
  </li>
  <li [ngClass]="item.classes" *ngIf="item.url && item.external">
    <a [target]="item.target ? '_blank' : '_self'" [href]="item.url">
      <ng-container *ngTemplateOutlet="itemIcon"></ng-container>
      <span class="pcoded-mtext" *ngIf="item.icon; else directTitle">{{ item.title }}</span>
      <ng-container *ngTemplateOutlet="item.radio"></ng-container>
      <ng-template #directTitle>
        {{ item.title }}
      </ng-template>
      <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
    </a>
  </li>
 

  <ng-template #itemIcon>
    <span *ngIf="item.icon" class="pcoded-micon"><i class="fa" [ngClass]="item.icon"></i></span>
    <img *ngIf="item.image" [src]=item.image class="sidebar-images" />
  </ng-template>
  <ng-template #itemBadge>
    <span *ngIf="item.badge && themeLayout === 'vertical'" class="pcoded-badge label" [ngClass]="item.badge.type">
      {{ item.badge.title }}
    </span>
    <span *ngIf="item.badge && themeLayout === 'horizontal'" class="badge label" [ngClass]="item.badge.type">
      {{ item.badge.title }}
    </span>


  </ng-template>
</ng-container>



